<span
  class="e-splash-loader"
  [style.width.px]="size()"
  [style.height.px]="size()"
  role="status"
  aria-hidden="true"
>
  <span class="e-splash-loader__track"></span>
  <span class="e-splash-loader__arc"></span>
  <span class="e-splash-loader__dot"></span>
</span>
